module.exports = __webpack_public_path__ + "img/image_one.a837030c.png";